import React from 'react';
import classNames from 'classnames';
import style from './style.module.scss';
var defaultProps = {
  theme: 'default',
  alignment: 'right'
};

var InputError = function InputError(_ref) {
  var _classNames;

  var children = _ref.children,
      theme = _ref.theme,
      alignment = _ref.alignment,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style['input-error'], style[theme], (_classNames = {}, _classNames[style[alignment]] = theme === 'material', _classNames), className)
  }, children);
};

InputError.defaultProps = defaultProps;
export default InputError;